import React, { useState } from "react";
import { MOVIMIENTOS } from "../../constants/mockData";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./MyTransactions.css";
import TableMovements from "../TableMovements/TableMovements";

const MyTransactions = ({ fundId, fundName }) => {
  // Filtrar movimientos solo del fondo actual
  const [transactions] = useState(
    MOVIMIENTOS.filter(mov => !fundId || mov.fund_id === fundId).map(mov => ({
      tipo: mov.tipo,
      fecha: mov.fecha,
      saldo: mov.saldo,
      estado: mov.status === "completado" ? "Completado" : mov.status === "pendiente" ? "Pendiente" : mov.status,
      movimiento: mov.movimiento,
      proyecto_c: fundName || mov.proyecto_c
    }))
  );

  // Filtros
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroFecha, setFiltroFecha] = useState("");
  const [filtroSaldo, setFiltroSaldo] = useState("");

  // Filtrar datos
  const transFiltradas = transactions.filter((t) => {
    return (
      (filtroTipo ? t.movimiento === filtroTipo : true) &&
      (filtroEstado ? t.estado === filtroEstado : true) &&
      (filtroFecha ? t.fecha === filtroFecha : true) &&
      (filtroSaldo ? t.saldo >= parseFloat(filtroSaldo) : true)
    );
  });

  // Obtener tipos únicos de movimientos
  const movimientosUnicos = Array.from(new Set(transactions.map(m => m.movimiento))).filter(Boolean);

  return (
    <Container fluid className="pt-4">
      {/* Filtros */}
      <Row className="mb-4 g-3 search-filters">
        <Col md={3}>
          <Form.Select
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
          >
            <option value="">Filtrar por tipo</option>
            {movimientosUnicos.map(mov => (
              <option key={mov} value={mov}>{mov}</option>
            ))}
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Select
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
          >
            <option value="">Filtrar por estado</option>
            <option value="Completado">Completado</option>
            <option value="Pendiente">Pendiente</option>
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Control
            type="date"
            value={filtroFecha}
            onChange={(e) => setFiltroFecha(e.target.value)}
            placeholder="Filtrar por fecha"
          />
        </Col>
        <Col md={3}>
          <Form.Control
            type="number"
            value={filtroSaldo}
            onChange={(e) => setFiltroSaldo(e.target.value)}
            placeholder="Saldo mínimo"
          />
        </Col>
      </Row>

      <Row>
        {/* Documentos */}
        <Col md={3} className="d-flex flex-column gap-3">
          <Card className="p-3 d-flex flex-row align-items-center container-doc m-0">
            <div className="box-icon">
              <i className="bi bi-file-earmark-text me-3"></i>
            </div>
            <div className="box-text">
              <h6>Vinculaciones</h6>
              <a href="/doc1.pdf" target="_blank" rel="noreferrer">
                Ver documento
              </a>
            </div>
          </Card>
          <Card className="p-3 d-flex flex-row align-items-center container-doc m-0">
            <div className="box-icon">
              <i className="bi bi-file-earmark-text me-3"></i>
            </div>
            <div className="box-text">
              <h6>Cesiones</h6>
              <a href="/doc2.pdf" target="_blank" rel="noreferrer">
                Ver documento
              </a>
            </div>
          </Card>
        </Col>

        {/* Tabla */}
        <Col md={9}>
          <TableMovements customData={transFiltradas} />
        </Col>
      </Row>
    </Container>
  );
};

export default MyTransactions;
